import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CatButton } from "blocks-nextjs/blocks-react/components/Button/Button";
import { CatModal } from "blocks-nextjs/blocks-react/components/Modal/Modal";
import React, { useCallback, useState } from "react";
import { createPortal } from "react-dom";
import useAppConfigStore from "../../store/useAppConfigStore";
const ACTIONS = [
    {
        buttonLabel: "Ignore",
        buttonVariant: "ghost-danger",
        className: "border-2 border-[#c52320] rounded-md",
        confirmLabel: "Ignore",
        dataTestButton: "ignore-from-site-button",
        dataTestCancel: "ignore-cancel-button",
        dataTestConfirm: "ignore-confirm-button",
        dataTestModal: "ignore-confirm-modal",
        message: "The asset will be ignored on the site and will not be present on the dashboard. It can be restored at any time.",
        size: "sm"
    },
    {
        buttonLabel: "Delete from Site",
        buttonVariant: "danger",
        confirmLabel: "Delete from Site",
        dataTestButton: "delete-from-site-button",
        dataTestCancel: "delete-cancel-button",
        dataTestConfirm: "delete-confirm-button",
        dataTestModal: "delete-confirm-modal",
        message: "This asset will be removed from the site, but it won\u0027t be permanently deleted.",
        size: "sm"
    }
];
const DeleteAssetModal = ({ onConfirmDelete, onConfirmIgnore }) => {
    const [activeModal, setActiveModal] = useState(null);
    const { appConfig } = useAppConfigStore((state) => ({ appConfig: state.appConfig }));
    const handlers = {
        "delete-confirm-modal": onConfirmDelete,
        "ignore-confirm-modal": onConfirmIgnore
    };
    const handleConfirm = useCallback((key) => {
        setActiveModal(null);
        handlers[key]?.();
    }, [onConfirmDelete, onConfirmIgnore]);
    if (!appConfig?.release_1_1?.showGhostAssetPhaseThree)
        return null;
    return (_jsx("div", { className: "flex gap-3", children: ACTIONS.map((action) => (_jsxs(React.Fragment, { children: [_jsx(CatButton, { className: action.className, "data-test": action.dataTestButton, onClick: () => setActiveModal(action.dataTestModal), size: action.size, variant: action.buttonVariant, children: action.buttonLabel }), activeModal === action.dataTestModal &&
                    createPortal(_jsxs(CatModal, { className: "[&::part(close)]:hidden", "data-test": action.dataTestModal, disableBackdropClick: true, heading: "Are you sure?", headingVariant: "title", isActive: true, onBlModalClose: () => setActiveModal(null), size: "sm", children: [_jsx("p", { className: "text-[#3F3F3F]", children: action.message }), _jsxs("div", { className: "flex gap-3", slot: "footer", children: [_jsx(CatButton, { "data-test": action.dataTestConfirm, onClick: () => handleConfirm(action.dataTestModal), variant: "danger", children: action.confirmLabel }), _jsx(CatButton, { "data-test": action.dataTestCancel, onClick: () => setActiveModal(null), variant: "ghost", children: "Cancel" })] })] }), document.body)] }, action.dataTestModal))) }));
};
export default DeleteAssetModal;
